import {
    FETCH_REMINDER_TEMPLATES_REQUEST,
    FETCH_REMINDER_TEMPLATES_SUCCESS,
    FETCH_REMINDER_TEMPLATES_FALUIRE,
} from './projectReminderTemplatesTypes'

const initialState = {
    loading: false,
    reminderTemplates: [],
    error: '',
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_REMINDER_TEMPLATES_REQUEST:
            return {
                ...state,
                loading: true,
            }
        case FETCH_REMINDER_TEMPLATES_SUCCESS:
            return {
                ...state,
                loading: false,
                reminderTemplates: Array.isArray(action.payload) ? action.payload : [],
                error: '',
            }
        case FETCH_REMINDER_TEMPLATES_FALUIRE:
            return {
                ...state,
                loading: false,
                reminderTemplates: [],
                error: action.payload,
            }
        default:
            return state
    }
}

export default reducer
